import styled, { css, keyframes } from "styled-components";
import { skeletonAnimation } from "./Animations.ts";

type BiggieSmall = {
    variant?: "disabled";
    weight?: "bold" | "default";
};
export const BiggieSmall = styled.small<BiggieSmall>`
    color: inherit;
    ${(props) =>
        props.variant === "disabled" &&
        css`
            color: var(--disabled-text) !important;
        `}
    font-family: Montserrat-normal, sans-serif;
    ${(props) => props.weight === "bold" && "font-weight: bolder;"}
    font-size: 0.85rem;
`;
export const Title = styled.h1`
    font-size: 2.5rem;
    font-weight: 800;
    line-height: 3rem;
    text-align: center;
`;

type GigaTitleProps = {
    center?: boolean;
};

export const GigaTitle = styled.h1<GigaTitleProps>`
    font-size: 3rem;
    color: var(--logo-text);
    font-family: Montserrat-Black, sans-serif;
    line-height: 3rem;
    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}
`;

type TextSkeletonProps = {
    variant: "giga" | "h1" | "p" | "small";
    width_percentage: number;
    fixed_width_rem?: number;
};

export const TextSkeleton = styled.div<TextSkeletonProps>`
    border-radius: var(--border-radius);
    height: ${(props) => {
        switch (props.variant) {
            case "giga":
                return "3rem";
            case "h1":
                return "1.5rem";
            case "p":
                return "1.25rem";
            case "small":
                return "1rem";
        }
    }};
    width: ${(props) => (props.fixed_width_rem ? `${props.fixed_width_rem}rem` : `${props.width_percentage}%`)};
    ${skeletonAnimation};
`;

type ErrorMessage = {
    shake?: boolean;
};
const shake = keyframes`
    0% {
        transform: translate(10px);
    }
    20% {
        transform: translate(-10px);
    }
    40% {
        transform: translate(5px);
    }
    60% {
        transform: translate(-5px);
    }
    80% {
        transform: translate(8px);
    }
    100% {
        transform: translate(0px);
    }
`;
export const ErrorMessage = styled.small<ErrorMessage>`
    color: var(--danger);

    ${(props) =>
        props.shake &&
        css`
            animation-name: ${shake};
            animation-duration: calc(var(--duration) * 2);
            animation-iteration-count: 1;
            animation-direction: alternate;
            animation-timing-function: ease-in-out;
        `}
`;
export const Comment = styled.small`
    color: var(--disabled-text);
`;
